import { createAction, createReducer } from '@reduxjs/toolkit';
import type {
    BuyAction,
    HasErrorAction,
    SetLinkAction,
    SetRenewalCostAction,
    StartLoadingAction,
    State,
} from 'reactApp/modules/billing/billing.types';

const INITIAL_STATE: State = {
    isLoading: false,
    isLoaded: false,
    hasError: false,
    link: '',
    renewLink: '',
    requestId: '',
    freemiumIsLoading: false,
    freemiumIsLoaded: false,
};

const buySubscription = createAction<BuyAction>('billing/buySubscription');
const renewSubscription = createAction<BuyAction>('billing/renewSubscription');
const getFreemium = createAction('billing/getFreemium');
const freemiumIsLoaded = createAction('billing/getFreemiumIsLoaded');

const setLink = createAction<SetLinkAction>('billing/setLink');
const setRenewLink = createAction<SetLinkAction>('billing/setRenewLink');
const setRenewalCost = createAction<SetRenewalCostAction>('billing/setRenewalCost');
const resetLink = createAction('billing/resetLink');
const hasError = createAction<HasErrorAction>('billing/hasError');
const startLoading = createAction<StartLoadingAction>('billing/startLoading');

export const billingReducer = createReducer(INITIAL_STATE, {
    [resetLink.type]: () => INITIAL_STATE,
    [setLink.type]: (state, action: ReturnType<typeof setLink>) => {
        const { link, requestId } = action.payload;

        if (requestId !== state.requestId) {
            return;
        }

        state.link = link;
        state.isLoaded = true;
        state.isLoading = false;
    },
    [setRenewLink.type]: (state, action: ReturnType<typeof setRenewLink>) => {
        const { link, requestId } = action.payload;

        if (requestId !== state.requestId) {
            return;
        }

        state.renewLink = link;
        state.isLoaded = true;
        state.isLoading = false;
    },
    [setRenewalCost.type]: (state, action: ReturnType<typeof setRenewalCost>) => {
        const { renewalCost, requestId } = action.payload;

        if (requestId !== state.requestId) {
            return;
        }

        state.renewalCost = renewalCost;
    },
    [startLoading.type]: (state, action: ReturnType<typeof startLoading>) => {
        const { requestId } = action.payload;

        state.requestId = requestId;
        state.isLoading = true;
        state.isLoaded = false;
    },
    [hasError.type]: (state, action: ReturnType<typeof hasError>) => {
        const { requestId } = action.payload;

        if (requestId !== state.requestId) {
            return;
        }

        return {
            ...INITIAL_STATE,
            hasError: true,
        };
    },
    [buySubscription.type]: (state) => {
        state.isLoading = true;
    },
    [renewSubscription.type]: (state) => {
        state.isLoading = true;
    },
    [getFreemium.type]: (state) => {
        state.freemiumIsLoading = true;
        state.freemiumIsLoaded = false;
    },
    [freemiumIsLoaded.type]: (state) => {
        state.freemiumIsLoading = false;
        state.freemiumIsLoaded = true;
    },
});

export const BillingActions = {
    setLink,
    setRenewLink,
    resetLink,
    buySubscription,
    renewSubscription,
    hasError,
    startLoading,
    setRenewalCost,
    getFreemium,
    freemiumIsLoaded,
};
